import React, { Fragment } from "react";
import Header from "../components/Header";
import BlogPage from "../templates/Blog";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import SEO from '../components/SEO';

const PageBlogGrid = () => {
  return (
    <Fragment>
      <Header />
      <BlogPage blog_type={"grid"} sidebar={false} sidebar_position={"left"} />
      <SEO/>
      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default PageBlogGrid;
